export const SERVICES_TASK_RENDER_TYPE = (type) => {
  switch (type) {
    case "1":
      return "In Warranty";
    case "2":
      return "No Warranty";
    default:
      break;
  }
};

export const SERVICES_TASK_RENDER_CALL_STATUS = (type) => {
  switch (type) {
    case "1":
      return "YES";
    default:
      return "-";
  }
};

export const SERVICES_TASK_RENDER_SERVICE_STATUS = (type) => {
  switch (type) {
    case "1":
      return "YES";
    default:
      return "-";
  }
};

export const SERVICES_TASK_RENDER_STATUS = (type) => {
  switch (type) {
    case "1":
      return "YES";
    default:
      return "-";
  }
};

export const SERVICES_SUB_TASK_RENDER_PROMOTION = (type) => {
  switch (type) {
    case "1":
      return { en: "Main Promotion", th: "Main Promotion" };
    case "2":
      return { en: "E-Voucer Code", th: "E-Voucer Code" };
    default:
      return { en: "", th: "" };
  }
};

export const RENDER_SUB_TASK_STATUS = (type) => {
  switch (type) {
    case "1":
      return {
        th: "ดำเนินการ",
        en: "Pending",
      };
    case "2":
      return {
        th: "จูนสำเร็จ",
        en: "Complete",
      };
    case "3":
      return {
        th: "ยกเลิก",
        en: "Cancel",
      };
    default:
      return { en: "", th: "" };
  }
};
